(function () {
  'use strict';

  function SidebarMyOrderController (sidebarMyOrderFactory, Common, moment, $state, $location,
    $scope, $rootScope, productsFactory) {
    const vm = this;

    function fetchPrices () {
      const options = {};
      const productDelivery = Common.get('productDelivery', productsFactory.getDefaultProductDelivery());
      const ownMaterial = productDelivery.ownMaterial;
      const singleSided = productDelivery.singleSided;
      const siteCategory = productDelivery.siteCategory; //might as well draw this from the product
      let materialDetails = Common.get('materialDetails', false);
      if (ownMaterial) {
        materialDetails = Common.get('productDelivery.odrDetails.materialDetails', {});
      }
      const recipients = {
        FILE: parseInt(Common.get('recipients.validAddressCount', 0)),
        COMPANIES: parseInt(Common.get('recipients.refinedAddressCount', 0)),
        INDIVIDUALS: parseInt(Common.get('recipients.refinedAddressCount', 0)),
        ODR: parseInt(Common.get('recipients.refinedAddressCount', 0))
      };

      Common.set('pricing', {});
      if (productDelivery.productId) {
        options.productId = productDelivery.productId;
        options.addressType = Common.get('recipients.addressType'); //FIXME Need to set addressType for ADR/ODR/ODRCompany
        options.deliveryDate = productDelivery.deliveryDate;

        const deliveryOptions = productDelivery.pricingInfo.deliveryOptions;

        if (angular.isArray(deliveryOptions)) {
          // options.deliveryId = deliveryOptions[0].id;
          options.deliveryId = productsFactory.getAvailableOptionId(options.addressType, deliveryOptions);

          // if (options.addressType === 'ODR') {
          //   options.deliveryId = deliveryOptions.filter((item) => {
          //     return item.addressType === 'ODR';
          //   })[0].id;
          // }
        } else {
          options.deliveryId = deliveryOptions.id;
        }

        if (!ownMaterial) {
          //read extraPages here as well, needs to be defined though
          let pages = Number(materialDetails ? materialDetails.numberOfPages.original : 1);
          if (!productDelivery.pageCountForCalculations) { //would mess up admail / flyers
            const preface = Common.get('preface', false);

            if (preface) {
              pages += (singleSided ? 1 : 2);
            } else if (siteCategory === 'paymentSlips' && !singleSided) { //blank backside for slips
              pages += 1;
            }

            if (!singleSided) {
              pages = _.round(pages / 2);
            }
          }
          options.numberOfPages = pages;
        }

        options.numberOfRecipients = recipients[Common.get('recipients.targetType', 'FILE')];
        options.recipientsData = Common.get('recipients.zoneCount');
        options.country = pnTopbar.market;
        options.language = 'none';
        options.userType = $rootScope.isNCPUser() ? 'company' : 'public';
        options.discountPostalCodeCount = parseInt(Common.get('recipients.discountPostalCodeCount', 0));
        options.addReferenceSamples = Common.get('addReferences');
        options.targetType = Common.get('recipients.targetType'); //used to check if addresses should be paid for

        if (ownMaterial) {
          options.terminalType = Common.get('productDelivery.odrDetails.center', productsFactory.getODRCenters()[1].unitType);
          options.itemWeight = materialDetails.weight || 1;
        }

        // when ODR, target type changes according to deliveryId
        // INDIVIDUALS - standard
        // COMPANIES - exclusive
        if (options.addressType === 'ODR') {
          options.targetType = Common.get('recipients.targetType');
          options.blockCount = Common.get('recipients.blockAddressCount');
          options.formOfHousing = Common.get('recipients.odrFilters')[options.targetType].formOfHousing;
          options.highTraffic = Common.get('weekInfo', {}).highTraffic || false;
          options.terminalType = Common.get('productDelivery.odrDetails.center', productsFactory.getODRCenters()[0].unitType);
        }
        if (isValidFetchPriceOptions(options)) {
          sidebarMyOrderFactory.fetchPricesFromBackend(options);
        }
      }

    }

    // validation base from pricing repo
    function isValidFetchPriceOptions (options) {
      return options.productId && options.numberOfRecipients;
    }

    function getAddressProcessing () {
      return sidebarMyOrderFactory.addressProcessing;
    }

    function getDate () {
      return moment(vm.sidebarDetails.product.deliveryDate).format('YYYY-MM-DD');
    }

    function goTo (state) {
      if (state === 'main') {
        $location.path('/');
        return;
      }

      $state.go(state);
    }

    function updateSidePanelDetails () {
      sidebarMyOrderFactory.getSidebarDetails(vm.landingSelection);
      vm.sidebarDetails = sidebarMyOrderFactory.sidebarDetails;
    }

    function updateTempDetails (keys) {
      Object.keys(keys).forEach(function (key) {
        vm.sidebarDetails[key] = keys[key];
      });
    }


    function checkSendoutName () {
      let showIcon = false;
      const sendoutName = Common.get('sendoutName', null);
      if (sendoutName) {
        showIcon = true;
      }
      return showIcon;

    }

    function showPc () {
      return Common.get('pricing', false);
    }

    function disablePaymentLink () {
      return Object.keys(vm.sidebarDetails.pricing).length;
    }

    function activate () {
      const observers = [{
        'name': 'web2print.pricing',
        'cb': fetchPrices
      }, {
        'name': 'updateSidePanelDetails',
        'cb': updateSidePanelDetails
      }, {
        'name': 'updateTempDetails',
        'cb': updateTempDetails
      }];

      vm.language = pnTopbar.language;

      sidebarMyOrderFactory.registerObservers(observers);

      vm.getDate = getDate;
      vm.goTo = goTo;
      vm.getAddressProcessing = getAddressProcessing;
      vm.checkSendoutName = checkSendoutName;
      vm.showPc = showPc;
      vm.disablePaymentLink = disablePaymentLink;

      const productDelivery = Common.get('productDelivery', false);
      vm.ownMaterial = productDelivery.ownMaterial;
      if (productDelivery) { //I'm sure this can be written in a better way, little bit tired :D (sorry!)
        if (!vm.ownMaterial && Common.get('productDelivery.odrDetails', false)) {
          fetchPrices();
        } else if (vm.ownMaterial) {
          fetchPrices();
        }
      }


      updateSidePanelDetails();
      $scope.$on('changeLanguage', function (events, language) {
        vm.language = language;
      });
    }

    activate();
  }

  angular.module('web2print.sidebar.myorder')
    .controller('SidebarMyOrderController', SidebarMyOrderController);

  SidebarMyOrderController.$inject = ['sidebarMyOrderFactory', 'Common', 'moment', '$state', '$location', '$scope',
    '$rootScope', 'productsFactory'];
})();
